<template>
    <modal :modal-id="userAndRoles.users.inviteModalId"
           v-model="showModal"
           :title="modalTitle"
           :preloader="preloader"
           :modal-scroll="false"
           @submit="submit"
           @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form ref="form"
                  :data-url='hasData ? `admin/auth/users/attach-roles/${userAndRoles.rowData.id}` : `/admin/auth/users/invite-user`'
                  :class="{'loading-opacity': preloader}">
                <div class="form-group row align-items-center" v-if="!hasData">
                    <label for="userEmail" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="userEmail"
                               class="col-sm-9"
                               type="email"
                               v-model="user.email"
                               :placeholder="$t('enter_user_email')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="roles" class="col-sm-3 mb-0">
                        {{ $t('role') }}
                    </label>
                    <app-input id="roles"
                               class="col-sm-9"
                               type="multi-select"
                               :list="roleLists"
                               list-value-field="name"
                               :isAnimatedDropdown="true"
                               v-model="roles"
                               :required="true"
                    />
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label for="teams" class="col-sm-3 mb-0">
                        {{ $t('team') }}
                    </label>
                    <app-input id="teams"
                               class="col-sm-9"
                               type="multi-select"
                               :list="teamLists"
                               list-value-field="name"
                               :isAnimatedDropdown="true"
                               v-model="teams"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0"></label>
                    <div class="col-sm-9">
                        <a href="#" @click.prevent="selectAllTeam">{{$t('select_all')}}</a>
                        <a href="#" class="ml-3" @click.prevent="deselectAllTeam" v-if="teams.length">{{$t('deselect_all')}}</a>
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
import {ModalMixin} from '../../../../mixins/ModalMixin';
import {UserAndRoleMixin} from '../Mixins/UserAndRoleMixin';
import * as actions from '../../../../config/ApiUrl';
import {SELECTABLE_TEAMS} from "../../../../config/ApiUrl";

export default {
    name: "UserInvitationModal",
    mixins: [FormMixin, ModalMixin, UserAndRoleMixin],
    data() {
        return {
            user: {},
            roles: [],
            teams: [],
            roleLists: [],
            teamLists: [],
            hasData: false,
            modalTitle: this.$t('invite_users'),
        }
    },
    created() {
        if (!_.isEmpty(this.userAndRoles.rowData)) {
            this.hasData = true;
            this.modalTitle = this.$t('manage_role'),
                this.user.email = this.userAndRoles.rowData.email;
            this.roles = this.userAndRoles.rowData.roles.map(function (roles) {
                return roles.id;
            });
            this.teams = this.userAndRoles.rowData.teams.map(function (teams) {
                return teams.id;
            });
        }
        this.getRoles();
        this.getTeams();
    },
    methods: {

        submit() {
            this.user.roles = this.roles;
            this.user.teams = this.teams;
            this.save(this.user);
        },

        afterSuccess(res) {
            this.$toastr.s(res.data.message);
            this.reLoadTable();
        },
        getRoles() {
            let url = actions.ROLES;

            this.preloader = this.hasData ? true : false;

            this.axiosGet(url).then(response => {

                this.roleLists = response.data.data;

            }).catch(({response}) => {

            }).finally(() => {
                this.preloader = false;
            });
        },
        getTeams() {
            this.preloader = this.hasData ? true : false;

            this.axiosGet(SELECTABLE_TEAMS).then(response => {

                this.teamLists = response.data;

            }).catch(({response}) => {

            }).finally(() => {
                this.preloader = false;
            });
        },
        selectAllTeam() {
            this.deselectAllTeam()
            this.teams = this.teamLists.map(team => team.id);
        },
        deselectAllTeam() {
            this.teams = []
        }
    }
}
</script>